<script>
  import { phoneWidth } from './stores.js';
  import Fa from 'svelte-fa';
  import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

  let innerWidth;
  let innerHeight;

  $: isPhone = innerWidth < phoneWidth;
</script>

<svelte:window bind:innerHeight bind:innerWidth />

<div class="container">
  <div class="hero-video-wrapper">
    <video
      class="hero-video"
      poster="/imgs/poster.jpeg"
      muted
      autoplay
      loop
      playsinline
    >
      {#if isPhone}
        <source src="video/MejuBgVer.mp4" type="video/mp4" />
      {:else}
        <source src="video/MejuBgHor.mp4" type="video/mp4" />
      {/if}
      <!-- <source src="video/MejuBg2.webm" type="video/webm" /> -->
      <strong>Your browser does not support the video tag.</strong>
    </video>
  </div>
  <div class="hero-text">
    {#if innerWidth < phoneWidth}
      <h1>
        당신의 <strong>소중한 시간</strong><br />
        당신만의 <strong>공간</strong>
      </h1>
    {:else}
      <h1>
        당신의 <strong>소중한 시간</strong>, 당신만의 <strong>공간</strong>
      </h1>
    {/if}
    <p>
      PREMIUM RENTAL SPACE <span class="spacing" />|<span
        class="spacing"
      /><strong>황금메쥬</strong>
    </p>
  </div>
  <a href="#intro" class="hero-button"
    >살펴보기<span class="spacing" /><Fa icon={faAngleDown} size="xs" /></a
  >
</div>

<style>
  .container {
    position: relative;
    font-weight: 100;
  }
  .hero-video-wrapper {
    width: 100%;
    height: 100vh;
  }

  .hero-video {
    /* position: absolute; */
    /* top: 0; */
    /* left: 0; */
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -2;
    filter: opacity(80%);
    background-color: whitesmoke;
  }
  .hero-text {
    position: absolute;
    top: 50%;
    width: 100%;
    transform: translateY(-50%);
    text-align: center;
    color: whitesmoke;
  }
  .hero-text h1 {
    font-size: 90px;
    font-weight: normal;
    margin: 0;
    margin-bottom: 25px;
  }
  .hero-text h1 strong {
    font-weight: 700;
    /* text-decoration: underline; */
  }
  .hero-text p {
    font-size: 32px;
    font-weight: 100;
    margin: 0;
  }
  .hero-text p strong {
    font-weight: 100;
  }

  .hero-button {
    border-radius: 5px;
    position: absolute;
    bottom: 10%;
    /* width: 10%; */
    left: 50%;
    transform: translate(-50%, -50%);
    width: 260px;
    height: 71px;
    background: rgba(255, 255, 255, 0.1);
    border: 3px solid #fdb501;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 0.3s;
    text-decoration: none;
    color: #f3f3f3;
    font-size: 30px;
  }
  .hero-button:hover {
    background: rgba(255, 255, 255, 1);
    color: #222;
    cursor: pointer;
    text-decoration: none;
  }
  .hero-button:active {
    text-decoration: none;
  }
  .hero-button .fa-angle-down {
    /* font-size: 20px; */
  }

  .spacing::after {
    content: '';
    margin-left: 10px;
  }

  @media screen and (max-width: 1400px) {
    .hero-text h1 {
      font-size: 6vw;
    }
    .hero-text p {
      font-size: 22px;
    }
    .hero-button {
      width: 180px;
      height: 50px;
      font-size: 20px;
    }
  }
  @media screen and (max-width: 768px) {
    .hero-text h1 {
      font-size: 11vw;
      margin-bottom: 6px;
    }
    .hero-text p {
      margin-top: 15px;
      font-size: 18px;
    }
    .hero-button {
      background: rgba(255, 255, 255, 0.6);
      color: #222;
      cursor: pointer;
    }
  }
</style>
